<ng-container *ngIf="templateOptions.style === 'button'">
  <mat-button-toggle-group name="dateSelection" (change)="onDateSelectionChange($event)">
    <ng-container *ngFor="let range of ranges">
      <mat-button-toggle [value]="range">{{ range.label }}</mat-button-toggle>
    </ng-container>
    <mat-button-toggle [value]="'custom'" *ngIf="this.templateOptions.custom"
      >{{ 'common.custom' | t }}</mat-button-toggle
    >
  </mat-button-toggle-group>
</ng-container>

<ng-container *ngIf="templateOptions.style === 'dropdown'">
  <mat-select
    [matTooltip]="searchRangeMessage ? searchRangeMessage : ''"
    [(value)]="dateSelection"
    (selectionChange)="onDateSelectionChange($event)"
    [placeholder]="templateOptions.label"
  >
    <ng-container *ngFor="let range of ranges">
      <mat-option [value]="range">{{ range.label }}</mat-option>
    </ng-container>
    <mat-option [value]="'custom'" *ngIf="this.templateOptions.custom">{{ 'common.custom' | t }}</mat-option>
    <mat-option *ngIf="searchRangeMessage" [value]="searchRangeMessage" disabled
      >{{ searchRangeMessage }}</mat-option
    >
  </mat-select>
</ng-container>
